import React from 'react';
import _ from 'lodash';

import {
  Box,
  styled,
  Typography
} from '@mui/material';
import {
  BaseWidget,
  LabelledText,
  OverallOrderStatusChip
} from 'modules';

import * as dataService from './dataService';



const RootBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between'
});

const OrderStatusBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}));



export interface IProps {
  orderId: string;
}

export const FC: React.FC<IProps> = props => {
  const tuple = dataService.useQuery(props.orderId);



  return _.isNil(tuple.data.order) ? null : (
    <BaseWidget.FC>
      <RootBox>
        <LabelledText.FC
          title="Order Number"
          text={tuple.data.order.orderNumber} />

        <LabelledText.FC
          title="Order Date"
          text={tuple.data.order.orderDate.toFormat('MMMM dd, yyyy')} />

        <OrderStatusBox>
          <Typography variant="h2">
            Status
          </Typography>

          <OverallOrderStatusChip.FC
            large
            statusName={tuple.data.order.orderStatusName}
            label={tuple.data.order.orderStatusDisplayName} />
        </OrderStatusBox>
      </RootBox>
    </BaseWidget.FC>
  );
};
